import { render, staticRenderFns } from "./ContribuicaoSindical.vue?vue&type=template&id=ddf084a6"
import script from "./ContribuicaoSindical.vue?vue&type=script&lang=js"
export * from "./ContribuicaoSindical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports